import styled from 'styled-components';

import { fonts, StatusBadge } from '@dreryk/react-components';

export const StyledStatusBadge = styled(StatusBadge)`
   font-weight: ${fonts.fontWeightNormal};
`;

StyledStatusBadge.displayName = 'StyledStatusBadge';
